import { InputState } from '../interface/ngrxInterfaces/input.state';
import { inputReducer } from './input/input.reducer';

import { ActionReducerMap } from '@ngrx/store';

import { AchievementManagementState } from '../interface/ngrxInterfaces/achievement-management.state';
import { achievementSelectedReducer } from './achievement-management/achievement-management.reducers';

import { AchievementFormState } from '../interface/ngrxInterfaces/achievement-form.state';
import { achievementFormReducer } from './achievement-form/achievement-form.reducers';
import { HomeAutoValorationReducer, HomeAutoValorationState } from './auto-valoration-form/auto-valoration.reducers';
import { HomeValorationReducer, HomeValorationState } from './valoration-form/valoration.reducers';
import { HomePragmaticInfoReducer, HomePragmaticInfoState } from './pragmatic-info/pragmatic-info.reducers';

export interface AppState {
  achievementCreateInput: InputState;
  // Borra la informacion del input en el form de la administracion de logros

  achievementManagement: AchievementManagementState;
  // Maneja el logro seleccionado y la informacion del logro y toda la lista de logros

  achievementForm: AchievementFormState;
  // Envia la informacion del formulario de la administracion de logros

  autoValorationHome:   HomeAutoValorationState;
  valorationHome: HomeValorationState;
  pragmaticInfoHome: HomePragmaticInfoState;
}

export const ROOT_REDUCERS: ActionReducerMap<AppState> = {
  achievementCreateInput: inputReducer,
  achievementManagement: achievementSelectedReducer,
  achievementForm: achievementFormReducer,
  autoValorationHome: HomeAutoValorationReducer,
  pragmaticInfoHome: HomePragmaticInfoReducer,
  valorationHome: HomeValorationReducer,
};
